import {getContentDescription} from '../../../ModelDetail/helpers/content-description.js'
const BASIC_VERSION_INDEX = 0

// Helper functions
const getBasicVersion = versions => ({
  ...versions[BASIC_VERSION_INDEX],
  length: versions[BASIC_VERSION_INDEX]?.length,
  width: versions[BASIC_VERSION_INDEX]?.width,
  height: versions[BASIC_VERSION_INDEX]?.height
})

export const getVehicleOverviewInfo = async ({domain, i18n, makeId, modelId, makeSlug, modelSlug}) => {
  const config = domain.get('config')
  const {MODEL_DETAIL_PAGE_NAME} = config.get('page')

  const [modelVersionsResult, modelDetailContentResult, vehicleContentResult] = await Promise.allSettled([
    domain.get('get_model_versions_vehicles_use_case').execute({
      makeId,
      modelId,
      pageName: MODEL_DETAIL_PAGE_NAME,
      includeInsights: true,
      onlyCurrentVersions: true
    }),
    domain.get('get_model_detail_content_vehicles_use_case').execute({
      makeId,
      modelId,
      make: makeSlug,
      model: modelSlug
    }),
    domain.get('get_vehicle_content_from_ai_vehicles_use_case').execute({
      makeId,
      modelId
    })
  ])

  const [getModelVersionsError, getModelVersionsResponse] = modelVersionsResult.value || []
  const [getModelDetailContentError, contentfulData] = modelDetailContentResult.value || []
  const [getVehicleContentFromAiError, vehicleContentData] = vehicleContentResult.value || []

  const {make, model, mainImage: dimensionsImage, items: versions, vehicleInsights} = getModelVersionsResponse

  const makeModel = `${make} ${model}`

  if (getModelVersionsError || getModelDetailContentError || getVehicleContentFromAiError) {
    console.error(getVehicleContentFromAiError)
  }

  const hasAIGeneratedContent = vehicleContentData?.value
  const body = contentfulData?.body
  const pros = vehicleContentData?.pros || contentfulData?.pros || []
  const cons = vehicleContentData?.cons || contentfulData?.cons || []
  const rating = vehicleContentData?.rating || contentfulData?.rating || []

  let description = vehicleContentData?.description || contentfulData?.description
  if (!description) {
    description = getContentDescription({makeModel, vehicleInsights, i18n})
  }

  const {length, width, height} = getBasicVersion(versions)

  return {
    body,
    cons,
    dimensionsImage,
    hasAIGeneratedContent,
    length,
    height,
    make,
    model,
    pros,
    rating,
    width
  }
}
